'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagCdAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M1.00136e-05 0C8.66668 4.6152e-06 19.3333 4.76837e-07 28 4.76837e-07C28.0001 6.66667 28 13.3333 28 20C18.6667 20 9.33334 20 1.00136e-05 20V0Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M1.00136e-05 0C8.66668 4.6152e-06 19.3333 4.76837e-07 28 4.76837e-07C28.0001 6.66667 28 13.3333 28 20C18.6667 20 9.33334 20 1.00136e-05 20V0Z",
          fill: "#158AFF"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M28 7.5L3.5 20H1.00136e-05L2.69413e-05 12.5L25 1.0252e-05L28 4.76837e-07V7.5Z",
          fill: "#FDD216"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M28 6L0.5 20H1.00136e-05L0 14L27.5 0L28 4.76837e-07V6Z",
          fill: "#CE1120"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4.66684 5.96665L2.70756 7.36337L3.43047 5.06837L1.49665 3.63659L3.90272 3.61492L4.66684 1.33331L5.43096 3.61492L7.83703 3.63659L5.90321 5.06837L6.62612 7.36337L4.66684 5.96665Z",
          fill: "#FDD216"
        }
      )
    ]
  }
);
const VpFlagCdAsset = forwardRef(FlagCdAsset);

export { VpFlagCdAsset as default };
